var _templateObject = _taggedTemplateLiteralLoose(['\n  display: flex;\n  height: 400px;\n  background-position: center;\n  background: url(', ');\n  background-size: cover;\n  box-shadow: 0 5px 10px 0;\n  margin-top: 30px;\n'], ['\n  display: flex;\n  height: 400px;\n  background-position: center;\n  background: url(', ');\n  background-size: cover;\n  box-shadow: 0 5px 10px 0;\n  margin-top: 30px;\n']),
  _templateObject2 = _taggedTemplateLiteralLoose(['\n  width: 100%;\n  height: 100%;\n  color: white;\n  padding-top: 30px;\n  background: linear-gradient(to top, ', ' 0%, ', ' 80%);\n'], ['\n  width: 100%;\n  height: 100%;\n  color: white;\n  padding-top: 30px;\n  background: linear-gradient(to top, ', ' 0%, ', ' 80%);\n']);
function _taggedTemplateLiteralLoose(strings, raw) {
  strings.raw = raw;
  return strings;
}
import React from 'react';
import styled from 'styled-components';
import { primary, primaryOpaque } from '../assets/colors';
import golfCourseImg from '../assets/img/golfCourse.jpg';
var ContentFrame = styled.div(_templateObject, function (props) {
  return props.img;
});
var TextFrame = styled.h2(_templateObject2, primaryOpaque, primary);
export default (function () {
  return React.createElement(ContentFrame, {
    img: golfCourseImg
  }, React.createElement(TextFrame, {
    className: 'text-center'
  }, 'Coming Soon!'));
});